import React from 'react'
import defaultTeamImg from '../../assets/images/team.png'
import './topSection.css'

const DraftTeam = ({ activeTeamCard }) => {
    return (
        <>
            {activeTeamCard && (
                <div className='col-sm-6'>
                    <div className='jumbotron jumbotron-custom padding-b45 padding-t35' 
                        style={{ 
                            backgroundColor: '#ef7f0f', 
                            background: `linear-gradient(90deg, ${activeTeamCard.LowColor}, ${activeTeamCard.HighColor})`, 
                            borderRadius: '20px', border: '1px solid #898989' 
                        }}
                    >
                        <div className='row align-items-center'>
                            {/* Image on the left on larger screens */}
                            <div className='col-md-12 col-lg-4 '>
                                <div className='player'>
                                    <img
                                        src={activeTeamCard.Logo ? activeTeamCard.Logo : defaultTeamImg}
                                        className='img-responsive img-circle img-user'
                                        style={{ border: '3px solid #4169E1' }}
                                    />
                                </div>
                            </div>
                            <div className='col-md-12 col-lg-8 text-md-start'>
                                <h2 className={`display-5 color-white ${activeTeamCard.PlayerID == 0 ? 'center-text margin-t0' : ''}`}>{activeTeamCard.DisplayName}</h2>
                                <h3 className='display-3 color-white'>{activeTeamCard.PlayerID != 0 ? 'Player Confirmed' : ''}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default DraftTeam